var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FDE7E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14519_30233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3339 21.3335H32.0006C30.5339 21.3335 29.3339 22.5335 29.3339 24.0002V28.0002H32.0006V25.3335H45.3339V46.6668H32.0006V44.0002H29.3339V48.0002C29.3339 49.4668 30.5339 50.6668 32.0006 50.6668H45.3339C46.8006 50.6668 48.0006 49.4668 48.0006 48.0002V24.0002C48.0006 22.5335 46.8006 21.3335 45.3339 21.3335ZM29.3472 37.9602L25.9472 34.5602L24.2539 36.2535L29.3339 41.3335L38.9206 31.7468L37.2272 30.0535L29.3472 37.9602Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14519_30233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneVerification);
export default __webpack_public_path__ + "static/media/phoneVerification.769f60b166575efe6525b3b68b2ca02c.svg";
export { ForwardRef as ReactComponent };